// extracted by mini-css-extract-plugin
export default {"container":"timer_container__H1nI6","time":"timer_time__T7Wz7"};